var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"page"},[_c('z-table',{attrs:{"columns":_vm.columns}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }